import React, { useState } from 'react';
import { Select, Form, Drawer, Button } from 'antd';
import FloatingLabel from '../../../components/FloatingLabel/FloatingLabel';
// import TaxItem from '../../../components/TaxItem/TaxItem';
import { ChevronDown, CheckCircle, CloseIcon, ChevronUp } from '../../../assets/icons';
// import { TaxData } from './DocumentsData';

const TaxDocuments = () => {
  const [yearIcon] = useState(false);
  const [yearIcon2, setYearIcon2] = useState(false);
  const [taxYear, setTaxYear] = useState();
  // const [typeIcon, setTypeIcon] = useState(false);
  const [typeIcon2, setTypeIcon2] = useState(false);
  const [formType, setFormType] = useState();
  const [taxDrawer, setTaxDrawer] = useState(false);
  return (
    <>
      <div className='data__header'>
        <h4>Taxes</h4>
        {/* NOTE: this will be implemented in future when taxes api will be integrated. */}
        {/* <p className='cursor-pointer filter-trigger' onClick={() => setTaxDrawer(true)}>
          <Filter verticalAlign='-7px' /> <span className='fw-600'>Filters</span> <span>(1)</span>{' '}
        </p> */}
      </div>
      <div className='nodata'>
        <p className='subhead-3 mb-4'>No tax documents found</p>
        <p className='mb-0'>All tax forms will appear here once available.</p>
      </div>
      {/* <div className='data__filters'>
        <Form>
          <Row gutter={16}>
            <Col span={8}>
              <FloatingLabel label='Tax Year' inputId='taxYear' inputValue={taxYear} className='filter-float' alwaysSmall>
                <>
                  <div className='filter-anchor' id='filter-year-anchor' />
                  <Form.Item name='taxYear'>
                    <Select
                      id='taxYear'
                      className='filter-select'
                      popupClassName='filter-select-dropdown'
                      onChange={(value) => setTaxYear(value)}
                      value={taxYear}
                      onDropdownVisibleChange={() => setYearIcon(!yearIcon)}
                      getPopupContainer={() => document.querySelector('#filter-year-anchor')}
                      suffixIcon={yearIcon ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                    >
                      <Select.Option value='2021'>
                        2021 <CheckCircle className='check' color='#8A4743' />{' '}
                      </Select.Option>
                      <Select.Option value='2022'>
                        2022 <CheckCircle className='check' color='#8A4743' />{' '}
                      </Select.Option>
                      <Select.Option value='2023'>
                        2023 <CheckCircle className='check' color='#8A4743' />{' '}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </>
              </FloatingLabel>
            </Col>
            <Col span={8}>
              <FloatingLabel label='Form Type' inputId='formType' inputValue={formType} className='filter-float' alwaysSmall>
                <>
                  <div className='filter-anchor' id='filter-type-anchor' />
                  <Form.Item name='formType'>
                    <Select
                      id='formType'
                      className='filter-select'
                      popupClassName='filter-select-dropdown'
                      onChange={(value) => setFormType(value)}
                      value={formType}
                      onDropdownVisibleChange={() => setTypeIcon(!typeIcon)}
                      getPopupContainer={() => document.querySelector('#filter-type-anchor')}
                      suffixIcon={typeIcon ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                    >
                      <Select.Option value='All'>
                        All <CheckCircle className='check' color='#8A4743' />{' '}
                      </Select.Option>
                      <Select.Option value='1099 Consolidated'>
                        1099 Consolidated <CheckCircle className='check' color='#8A4743' />{' '}
                      </Select.Option>
                      <Select.Option value='Schedule E - 1040'>
                        Schedule E - 1040 <CheckCircle className='check' color='#8A4743' />{' '}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </>
              </FloatingLabel>
            </Col>
          </Row>
        </Form>
      </div>
      <div className='data__items mb-48'>
        <div className='data__items__head'>
          <p className='subhead-3'>Tax year</p>
          <p className='subhead-3'>Form</p>
        </div>
        {TaxData.map((data, index) => {
          return <TaxItem key={index} year={data.year} form={data.form} action={data.action} />;
        })}
      </div> */}
      <Drawer
        className='filter-drawer'
        open={taxDrawer}
        footer={false}
        onClose={() => setTaxDrawer(false)}
        title={<p className='mb-0 subhead-3'>Filter Taxes</p>}
        closeIcon={<CloseIcon />}
        width='100%'
      >
        <Form className='filter-form'>
          <div className='filter-fields'>
            <FloatingLabel label='Tax Year' inputId='taxYear' inputValue={taxYear} className='filter-float'>
              <>
                <div className='filter-anchor' id='filter-year-anchor-2' />
                <Form.Item name='taxYear'>
                  <Select
                    id='taxYear'
                    className='filter-select'
                    popupClassName='filter-select-dropdown'
                    onChange={(value) => setTaxYear(value)}
                    value={taxYear}
                    onDropdownVisibleChange={() => setYearIcon2(!yearIcon2)}
                    getPopupContainer={() => document.querySelector('#filter-year-anchor-2')}
                    suffixIcon={yearIcon ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                  >
                    <Select.Option value='2021'>
                      2021 <CheckCircle className='check' color='#8A4743' />{' '}
                    </Select.Option>
                    <Select.Option value='2022'>
                      2022 <CheckCircle className='check' color='#8A4743' />{' '}
                    </Select.Option>
                    <Select.Option value='2023'>
                      2023 <CheckCircle className='check' color='#8A4743' />{' '}
                    </Select.Option>
                  </Select>
                </Form.Item>
              </>
            </FloatingLabel>
            <FloatingLabel label='Form Type' inputId='formType' inputValue={formType} className='filter-float'>
              <>
                <div className='filter-anchor' id='filter-type-anchor-2' />
                <Form.Item name='formType'>
                  <Select
                    id='formType'
                    className='filter-select'
                    popupClassName='filter-select-dropdown'
                    onChange={(value) => setFormType(value)}
                    value={formType}
                    onDropdownVisibleChange={() => setTypeIcon2(!typeIcon2)}
                    getPopupContainer={() => document.querySelector('#filter-type-anchor-2')}
                    suffixIcon={typeIcon2 ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                  >
                    <Select.Option value='All'>
                      All <CheckCircle className='check' color='#8A4743' />{' '}
                    </Select.Option>
                    <Select.Option value='1099 Consolidated'>
                      1099 Consolidated <CheckCircle className='check' color='#8A4743' />{' '}
                    </Select.Option>
                    <Select.Option value='Schedule E - 1040'>
                      Schedule E - 1040 <CheckCircle className='check' color='#8A4743' />{' '}
                    </Select.Option>
                  </Select>
                </Form.Item>
              </>
            </FloatingLabel>
          </div>
          <Button type='primary' className='w-100'>
            Apply Filters
          </Button>
        </Form>
      </Drawer>
    </>
  );
};

export default TaxDocuments;
